// services/api/chatbot/chatbot.query.ts
import { gql } from "graphql-request";

export const UPDATE_ORG_CHATBOT_CONFIG = gql`
  mutation UpdateOrgChatbotConfig(
    $orgId: String
    $itemId: String
    $kbFolderId: String
    $widgetId: String
  ) {
    updateorganizationconfig(
      where: { OrganizationIds: { contains: $orgId } }
      input: {
        chatbotConfig: {
          itemId: $itemId
          kbFolderId: $kbFolderId
          widgetId: $widgetId
        }
      }
    ) {
      acknowledged
      itemId
      totalImpactedData
      message
    }
  }
`;

export const GET_ORG_CHATBOT_CONFIG = gql`
  query GetOrgChatbotConfig($orgId: String) {
    getorganizationconfigs(where: { OrganizationIds: { contains: $orgId } }) {
      items {
        chatbotConfig {
          itemId
          kbFolderId
          widgetId
        }
      }
    }
  }
`;
